import create from "zustand";
import { persist } from "zustand/middleware";

const cartStore = (set) => ({
	addToCartIsSuccessful: false,
	buyingForInstitution: false,
	canBuyForInstitution: false,

	setAddToCartIsSuccessful: (addToCartIsSuccessful) => {
		set({ addToCartIsSuccessful });
	},

	setBuyingForInstitution: (buyingForInstitution) => {
		set({ buyingForInstitution });
	},

	setCanBuyForInstitution: (canBuyForInstitution) => {
		set({ canBuyForInstitution });
	},

	cart: [],
});

const useCartStore = create(
	persist(cartStore, {
		name: "zus-cart",
		getStorage: () => localStorage,
	})
);

export default useCartStore;
